import React from 'react'

import { SxProps } from '@mui/material'

import { useTranslation } from 'language/translator'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import { OptionProps } from 'components_new/molecules/OptionsMenu'
import OptionsMenuButton from 'components_new/molecules/OptionsMenuButton'

import { METRIC_PREVIEW_HEIGHT } from '.'
interface Props {
  editMode?: boolean
  options?: OptionProps[]
  sx?: SxProps
}

const Error = React.memo((props: Props) => {
  const { editMode, options, sx } = props

  const { t } = useTranslation()

  return (
    <EmptyPlaceholder
      menu={
        editMode && options ? <OptionsMenuButton options={options} /> : null
      }
      background={true}
      body={t('global', 'error_500_helper_text')}
      height={METRIC_PREVIEW_HEIGHT}
      icon="HeartBrokenTwoTone"
      orientation="vertical"
      sx={sx}
      title={`${t('global', 'error_500_title')} ${t(
        'key_metrics',
        'key_metric',
        true
      )}`}
    />
  )
})

export default Error
